import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        shape:
        {
            type: String,
            default: 'circle', // 'default', 'circle'
        },

        outline:
        {
            type: Boolean,
            default: false,
        },

        outlineShape:
        {
            type: String,
            default: null, // 'semi', 'full'
        },

        active:
        {
            type: Boolean,
            default: false,
        },

        color:
        {
            type: String,
            default: 'default', // 'default', 'primary', 'secondary'
        },

        label:
        {
            type: String,
            required: true,
        },

        size:
        {
            type: String,
            default: null, // 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'
        },

        src:
        {
            type: String,
            default: null,
        },

        subLabel:
        {
            type: String,
            default: null,
        },

        divClass:
        {
            type: String,
            default: ''
        }
    },


    render()
    {
        return h(
            'div',
            {
                // staticClass: data.staticClass,

                class:
                    [
                        'vh-avatar',
                        this.shape && `vh-avatar-${this.shape}`,
                        this.outline && 'vh-avatar-outline',
                        this.active && 'vh-active',
                        !this.color && `vh-avatar-${this.color}`,
                        this.size && `vh-avatar-${this.size}`,
                        this.src && 'vh-avatar-image',
                        this.outlineShape && `vh-avatar-outline-${this.outlineShape}-rounded`,
                        this.divClass
                    ],
            },
            [
                this.src
                    ? ''
                    : h(
                        'div',

                        {
                            class: 'vh-avatar-content',
                        },

                        [
                            h(
                                'div',

                                [
                                    h(
                                        'span',
                                        {
                                            class: 'vh-avatar-label',
                                        },
                                        this.label
                                    ),

                                    this.subLabel
                                        ? h(
                                            'span',
                                            {
                                                class: 'vh-avatar-sublabel',
                                            },
                                            this.subLabel
                                        )
                                        : '',
                                ]
                            ),
                        ]
                    ),

                this.src && h(
                    'img',
                    {
                        src: this.src,
                        alt: this.src,
                    }
                ),
            ]
        );
    },
};
